module.exports = __webpack_public_path__ + "img/logos.d6a9b788.png";